<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Cupons de Desconto</h1>
        <paragrafo>
          Nesta tela, você pode encontrar cupons de desconto que já foram
          cadastrados. Além disso, é possível cadastrar novos cupons e realizar
          alterações através do ícone de lápis. Caso necessário, você também
          pode excluir os cupons selecionados.
        </paragrafo>
        <paragrafo
          >A grade exibe informações relevantes sobre os cupons, como o código
          do cupom, a quantidade disponível, o percentual de desconto e o valor
          do desconto. Além disso, você pode realizar ações como editar os
          detalhes do cupom e excluí-lo, conforme necessário.</paragrafo
        >
        <imagem :src="image_1" />
        <paragrafo
          >Para criar um novo cadastro, clique em "Novo Cupom". Você deve
          preencher os seguintes dados obrigatórios:</paragrafo
        >
        <ul>
          <li>
            Código do cupom: Insira o código do cupom, por exemplo:
            PRIMEIRACOMPRA;
          </li>
          <li>
            Status: Selecione entre "Ativo" ou "Inativo" para definir o estado
            do cupom;
          </li>
          <li>
            Data de validade (início): Especifique a data de início de validade
            do cupom;
          </li>
          <li>
            Data de validade (fim): Especifique a data de término de validade do
            cupom;
          </li>
          <li>
            Quantidade: Indique a quantidade total disponível desse cupom;
          </li>
          <li>
            Quantidade por consumidor: Defina o limite de utilização por
            cliente;
          </li>
          <li>
            Tipo de desconto: Escolha entre "Valor" ou "Percentual" para o tipo
            de desconto aplicável;
          </li>
          <li>
            Valor do desconto ou percentual de desconto: Insira o valor ou
            percentual correspondente ao desconto oferecido pelo cupom;
          </li>
          <li>
            Valor mínimo do pedido ou valor máximo de desconto no pedido:
            Especifique um valor mínimo para o pedido ser elegível ao desconto
            ou limite máximo de desconto permitido no pedido;
          </li>
        </ul>
        <paragrafo
          >Abaixo está um exemplo de como preencher o cadastro de um cupom de
          desconto com a opção de desconto em <negrito>valor</negrito>. No caso,
          o cupom oferece um desconto de R$10,00 para pedidos com valor mínimo
          de R$100,00. Veja as informações a seguir como referência:</paragrafo
        >
        <imagem :src="image_2" />
        <paragrafo
          >Abaixo está um exemplo de como preencher o cadastro de um cupom de
          desconto com a opção de desconto em <negrito>percentual</negrito>. No
          caso, o cupom oferece um desconto de 10% com valor máximo de desconto
          de R$10,00. Veja as informações a seguir como referência:</paragrafo
        >
        <imagem :src="image_3" />
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Usuarios",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/documentacao/vendas/cupons1.png",
      image_2: "/documentacao/vendas/cupons2.png",
      image_3: "/documentacao/vendas/cupons3.png",
    };
  },
};
</script>
